import apiClient, { extractData } from '../api-client';

/**
 * Công nợ của chính CTV với xưởng — CHỈ ĐỌC.
 *
 * Sổ gốc nằm ở CMS tổng; bên này chỉ giữ bản sao do tổng đẩy về qua webhook.
 * Vì vậy không có hàm ghi nào ở đây, và cũng đừng thêm: CTV tự sửa được số nợ
 * của mình thì con số đó không còn nghĩa lý gì.
 */
export const myDebtApi = {
  /**
   * @returns {Promise<{so_du: number, sao_ke: Array}>}
   */
  get() {
    return apiClient.get('/my-debt').then(extractData);
  },
};

export default myDebtApi;
